import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { Layout } from '@/components/layout';
import { ProgressProvider, useProgress } from '@/hooks';
import {
  Home,
  Species,
  SpeciesDetail,
  Learn,
  Quiz,
  Achievements,
  Journey,
  Games,
} from '@/pages';
import { RiverRushGame, RescueMissionGame } from '@/games';

function AppContent() {
  const { progress } = useProgress();

  // Apply dark mode on mount and when setting changes
  useEffect(() => {
    if (progress.settings.darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [progress.settings.darkMode]);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="species" element={<Species />} />
        <Route path="species/:id" element={<SpeciesDetail />} />
        <Route path="learn" element={<Learn />} />
        <Route path="quiz" element={<Quiz />} />
        <Route path="achievements" element={<Achievements />} />
        <Route path="journey/:id" element={<Journey />} />
        <Route path="games" element={<Games />} />
      </Route>
      {/* Game routes without the main layout (full-screen games) */}
      <Route path="/games/river-rush" element={<RiverRushGame />} />
      <Route path="/games/rescue-mission" element={<RescueMissionGame />} />
    </Routes>
  );
}

function App() {
  return (
    <ProgressProvider>
      <AppContent />
    </ProgressProvider>
  );
}

export default App;
